import React, { useEffect, useState } from "react";
import { Button, Row, Col, Space, Badge } from "antd";
import styles from "./LicenseSettings.module.scss";
import { formatDate } from "../../Utils/Utils";
import { useLicenseSettings } from "./LicenseSettingsContext";
import { CustomerLicense } from "../../Utils/types";
import { useSelector } from "react-redux";
import { RootState } from "../../Redux/store";
import LicenseTransferModal from "./LicenseTransferModal";
import { showContactUsPage } from "./modals/modals";
import { hasFullLicenseOfSameType } from "./utils/LicenseManipulation";

interface LicenseSettingsModalProps {
  settings?: CustomerLicense;
  licenseName: string;
}

const LicenseSettingsModal: React.FC<LicenseSettingsModalProps> = ({
  settings: initialSettings,
  licenseName,
}) => {
  const { totalValue, trialStatus } = useLicenseSettings();
  const [modalVisible, setModalVisible] = useState(false);
  const [usedValueSetting, setUsedValueSettings] = React.useState<number>(
    Number(initialSettings?.usedValue) ?? 0
  );

  const customerLicenses = useSelector(
    (state: RootState) => state.user.licenseTypes
  );

  const hasOtherLicense = hasFullLicenseOfSameType(customerLicenses, initialSettings);

  const handleOpenTransferModal = () => {
    setModalVisible(true);
  };

  useEffect(() => {
    setUsedValueSettings(totalValue ?? 0);
  }, [totalValue]);
  return (
    <>
      <Space
        direction="vertical"
        style={{ width: "100%" }}
        className={styles.body}
      >
        <div className={styles.centeredTop}>
          <Row gutter={[{ xs: 4, sm: 8, md: 24, lg: 96 }, 10]}>
            <Col
              xs={24}
              sm={24}
              md={trialStatus ? 8 : 12}
              className={`${styles.dividerRight} ${
                !trialStatus && styles.adjustedColumn
              } ${styles.centerItemsMobile}`}
            >
              <div className={styles.ellipsisText}>
                <Badge color="blue" dot className={styles.badge} />
                <b>Number of Licenses: </b> {initialSettings?.value}
              </div>
              <div>
                <Badge color="green" dot className={styles.badge} />
                <b>Used: </b> {usedValueSetting}
              </div>
            </Col>
            <Col
              xs={24}
              sm={24}
              md={trialStatus ? 8 : 12}
              className={`${trialStatus ? styles.dividerRight : ""} ${
              styles.centerItemsMobile
              }`}
            >
              <div
              style={{ marginBottom: "10px", whiteSpace: "nowrap" }}
              className=""
              >
              <Badge status="default" className={styles.badge} />
              <b>Assign Date: </b> {formatDate(initialSettings?.assignDate)}
              </div>
              <div>
              {trialStatus ? (
                <>
                <Badge status="processing" className={styles.badge} />
                <b>Expire Date: </b>
                {formatDate(initialSettings?.lastOffDate)}
                </>
              ) : (
                <>
                <Badge
                  status={
                  initialSettings?.cgsStatus === "Active"
                    ? "success"
                    : "error"
                  }
                  className={styles.badge}
                />
                <b>Status: </b> {initialSettings?.cgsStatus}
                </>
              )}
              </div>
            </Col>
            {trialStatus && (
              <Col
              xs={24}
              sm={24}
              md={8}
              className={`${styles.centerItemsMobile} ${styles.centerThirdColumn}`}
              >
              {hasOtherLicense && totalValue > 0 ? (
                <Button type="primary" onClick={handleOpenTransferModal}>
                Transfer
                </Button>
              ) : (
                <Button
                type="primary"
                onClick={() => showContactUsPage(trialStatus)}
                >
                Activate
                </Button>
              )}
              </Col>
            )}
          </Row>
        </div>
        <hr className={styles.hrStyle} />
      </Space>
      {hasOtherLicense && (
        <LicenseTransferModal
          visible={modalVisible}
          setModalVisible={setModalVisible}
          transferToLicense={hasOtherLicense}
          customerLicenseId={initialSettings?.id!}
          licenseName={licenseName}
        />
      )}
    </>
  );
};

export default LicenseSettingsModal;
